export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9228.9b7322df.jpg";